export default function BrandNarrative() {
  return (
    <section className="py-24 md:py-32 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <p className="text-xs tracking-[0.25em] uppercase text-foreground-500 mb-6 font-label">Why Itaobuy</p>

        <div className="flex flex-col lg:flex-row lg:items-end gap-8 mb-16">
          <div className="lg:w-[55%]">
            <h2 className="font-heading text-5xl md:text-7xl font-bold text-foreground-950 leading-[1.05]">
              Stop Guessing.<br />
              Start Sourcing.
            </h2>
          </div>
          <div className="lg:w-[45%]">
            <p className="text-lg text-foreground-600 leading-relaxed">
              A filterable spreadsheet system built for dropshippers who refuse to waste hours on uncurated marketplaces. Itaobuy sheet gives you pre-analyzed product data instead of raw listings — so you spend time selling, not scrolling.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 -mt-8">
          <div className="lg:w-[42%] relative -mt-0 lg:-mt-12">
            <div className="rounded-2xl overflow-hidden border border-background-200/50" style={{ aspectRatio: "4/3" }}>
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20modern%20spreadsheet%20interface%20displayed%20on%20warm%20toned%20laptop%20screen%20with%20organized%20product%20data%20columns%20visible%20on%20light%20wooden%20desk%20soft%20natural%20window%20light%20editorial%20workspace%20photography%20minimal%20aesthetic%20with%20small%20potted%20plant%20beside%20computer&width=700&height=525&seq=narrative-sheet-v2&orientation=landscape"
                alt="Itaobuy spreadsheet interface preview"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
          <div className="lg:w-[58%]">
            <div className="rounded-2xl overflow-hidden border border-background-200/50 h-full" style={{ minHeight: "360px" }}>
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20overhead%20flatlay%20of%20curated%20fashion%20products%20including%20rust%20sneakers%20sage%20knitwear%20brown%20leather%20goods%20and%20ceramic%20home%20items%20arranged%20harmoniously%20on%20cream%20linen%20surface%20soft%20natural%20daylight%20editorial%20product%20photography%20warm%20earthy%20palette%20clean%20aesthetic&width=800&height=500&seq=narrative-products-v2&orientation=landscape"
                alt="Curated product collection flatlay"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}